export const GA_MEASUREMENT_ID = "G-3DG539KC3B";